import { render, staticRenderFns } from "./ModernCard.vue?vue&type=template&id=36730172&scoped=true"
import script from "./ModernCard.vue?vue&type=script&lang=js"
export * from "./ModernCard.vue?vue&type=script&lang=js"
import style0 from "./ModernCard.vue?vue&type=style&index=0&id=36730172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36730172",
  null
  
)

export default component.exports